import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from 'material-ui/styles';
import List, { ListItem } from 'material-ui/List';
import { OAuthSignOutButton } from 'components';
import Divider from 'material-ui/Divider';
import Loader from '/components/Loader';
import Stepper from './stepper';
import FormLoanDetails from './formLoanDetails';
import FormBorrowerDetails from './formBorrowerDetails';
import FormPersonalDetails from './formPersonalDetails';
import Paper from 'material-ui/Paper';
import SVG from 'react-inlinesvg';
import logo from 'logo.svg';
import {
  createOrFetchApplication,
  updateApplication,
  rewindApplication
} from 'actions/applications';
import CustomCheckbox from '/components/FormComponents/Checkbox';
import SimpleDialog from '/components/FormComponents/Dialog';
import TermsConditions from '/components/TermsConditions';

const styleSheet = (theme) => ({
  root: {
    backgroundColor: '#eee',
    flexGrow: 1,
    marginTop: theme.spacing.unit * 3,
    maxWidth: 900,
    margin: '0px auto'
  },
  paper: {
    padding: 16
  },
  signout: {
    float: 'right',
    marginRight: '15px',
    marginTop: '-20px',
  }
});

class Application extends Component {
  constructor(props) {
    super(props);
    this.state = { value: 0, termsAndConditions: false, errors: {} };
  };

  static propTypes = {
    application: PropTypes.object
  }

  componentWillMount = () => {
    const { dispatch } = this.props;
    dispatch(createOrFetchApplication());
  }

  handleGoBack = () => {
    const { dispatch, application } = this.props;
    dispatch(rewindApplication(application));
  }

  handleConfirmation = () => {
    if (!this.validateForm()) {
      return ;
    }
    const { dispatch, application } = this.props;
    dispatch(updateApplication(application, { lodged: true, termsAndConditions: this.state.termsAndConditions }));
  }

  handleTermsAndConditions = (event) => {
    this.setState({ termsAndConditions: event.target.checked, errors: {} })
  }

  validateForm = () => {
    if (!this.state.termsAndConditions) {
      this.setState({ errors: { termsAndConditions: "Must agree to terms and conditions to proceed." }});
      return false;
    }
    return true;
  }

  renderConfirmation = (application) => {
    return (
      <div>
        <h3>Please confirm the following details</h3>
        <FormLoanDetails application={application} confirmation />
        <FormBorrowerDetails application={application} confirmation />
        <FormPersonalDetails application={application} confirmation />
        <CustomCheckbox value="termsAndConditions" checked={this.state.termsAndConditions} onChange={this.handleTermsAndConditions} error={this.state.errors.termsAndConditions} />
        <TermsConditions/>
        <div style={{ textAlign: 'center'}}>
          <button className='btn btn-default' onClick={this.handleGoBack}>
            Go back
          </button>
          <button className='btn btn-primary' onClick={this.handleConfirmation} style={{ marginLeft: 15 }}>
            Confirm
          </button>
        </div>
      </div>
    );
  }

  renderStep = (application) => {
    switch (application.step) {
      case 'loan':
        return <FormLoanDetails application={application} showGoBack={false} />
      case 'borrower':
        return <FormBorrowerDetails application={application} />
      case 'personal':
        return <FormPersonalDetails application={application} />
      case 'confirmation':
        return this.renderConfirmation(application);
      default:
        console.log(`Unknown application step: ${application.step}`)
    }
  }

  renderLodged = (application) => {
    return (
      <div>
        <h4>Congratulations! Your application has been submitted for assessment. We'll contact you shortly.</h4>
        <div>Please write down your application number: <strong>{application.number}</strong> for further reference.</div>
      </div>
    );
  }

  renderMain = (application) => {
    switch (true) {
      case application.status === "lodged":
        return this.renderLodged(application);
      case application.updating:
        return <Loader />
      default:
        return this.renderStep(application);
    }
  }

  render = () => {
    const { classes, application } = this.props;
    if (application) {
      return (
        <div className={classes.root}>
          <OAuthSignOutButton className={classes.signout}/>
          <SVG src={logo} style={{ display: 'block', width: '100px', margin: '0 auto' }}/>
          <Paper style={{padding: 20, margin: 20}}>
            <Stepper application={application}/>
            <Divider style={{marginBottom: '15px'}}/>
            { this.renderMain(application) }
          </Paper>
        </div>
      );
    } else {
      return <Loader />;
    }
  }
}

const mapStateToProps = (state) => {
  const { application } = state;
  return { application };
};

const styled = withStyles(styleSheet)(Application)
const connected = connect(mapStateToProps)(styled);

export default connected;



// WEBPACK FOOTER //
// ./src/containers/Application/index.js